<template>
  <router-view></router-view>
</template>

<script>
export default {};
</script>

<style>
body {
  margin: 0;
  color: #2b3441;
}
ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
</style>
